import React from 'react';
import ButtonGroup from '../../../../../../../form/button-group';

class Buttons extends React.Component {
  render() {
    return <ButtonGroup {...this.props} debug={false} display="list" />;
  }
}

Buttons.defaultProps = {
  separator: ', '
};

export default Buttons;
